import { SET_GLOBAL_STATE, SET_ACTIVE_TYPES, TOGGLE_SELECTED_ITEM_TYPES, UPDATE_ITEMS_PAGE, REMOVE_NOTIFICATION, ADD_NOTIFICATION, SET_LOCALIZATION } from './actionTypes';
import { availableLocales, getLocale } from '../../shared/translations';

/* * * * * * * * * * *
* TOGGLE VIEW STATES *
* * * * * * * * * *  */
export const setGlobalState = (identifier = null, value) => {
    return {
        type: SET_GLOBAL_STATE,
        identifier: identifier,
        value: value
    };
};

export const setActiveTypes = (mainType = null, itemTypes = [], selectedItemTypeIds = []) => {
    return {
        type: SET_ACTIVE_TYPES,
        mainType: mainType,
        itemTypes: itemTypes,
        selectedItemTypeIds: selectedItemTypeIds
    };
};

export const updateSelectedItemTypes = (itemTypeId = null) => {
    return {
        type: TOGGLE_SELECTED_ITEM_TYPES,
        itemTypeId: itemTypeId
    };
};

export const updateItemsPage = (number = 1, size = 20) => {
    return {
        type: UPDATE_ITEMS_PAGE,
        number: number,
        size: size
    };
};

/* * * * * * * * * * *  *
* NOTIFICATIONS METHODS *
* * * * * * * * * * * * */
export const removeNotification = (id) => {
    // if id is null or undefined, all notifications will be removed, otherwise only notification with that id should be removed
    return {
        type: REMOVE_NOTIFICATION,
        id: id
    };
};

export const addNotification = (data) => {
    return {
        type: ADD_NOTIFICATION,
        data: data
    };
};

/* * * * * * * * * * * *
* LOCALIZATION METHODS *
* * * * * * * * * * *  */
export const setLocalization = (localeString) => {
    const locale = getLocale(localeString);
    return {
        type: SET_LOCALIZATION,
        available: availableLocales,
        locale: locale.id,
        language: locale.language,
        region: locale.region
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/global.js